import _assign from "object-assign";
import deepmerge from 'deepmerge';
export var defaultIconography = {
  small: {
    width: 15,
    height: 15,
    fontSize: 13
  },
  medium: {
    width: 25,
    height: 25,
    fontSize: 21
  }
};

var createPalette = function createPalette(_ref) {
  var type = _ref.type,
      grey60 = _ref.grey60,
      grey300 = _ref.grey300,
      grey900 = _ref.grey900,
      white = _ref.white;

  if (type === 'light') {
    return {
      color1: grey300,
      color2: white,
      color3: white
    };
  }

  return {
    color1: grey60,
    color2: grey900,
    color3: white
  };
};

var createIcon = function createIcon(_ref2) {
  var color1 = _ref2.color1,
      color2 = _ref2.color2,
      color3 = _ref2.color3;
  return {
    icon: {
      color: color1
    },
    iconInverted: {
      color: color2
    },
    iconSelected: {
      color: color3
    }
  };
};

export var createIconography = function createIconography(palette) {
  var iconography = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var otherOptions = typeof iconography === 'function' ? iconography(palette) : iconography;
  var iconPalette = createPalette(palette);

  var options = _assign({}, createIcon(iconPalette), defaultIconography);

  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return mergedOptions;
};